module.exports = __webpack_public_path__ + "img/staking.3ac99ec9.png";